import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { StyledFieldset } from "./Contact";
import { CheckoutModal } from "../components/Modal";
import { usePaystackPayment } from "react-paystack";
import { useSelector } from "react-redux";
import { Countries } from "../components";
import PayPal from "../assets/PayPal-Logo 1.png";
import visa from "../assets/Visa_Logo 1.png";
import mastercard from "../assets/MasterCard_Logo 1 (1).png";
import Radio from "@mui/material/Radio";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import "../styles/checkout.css";
import { PaystackHook } from "../hooks";
import { config } from "../paystackConfig";
import { selectUser } from "../services/userSlice";

interface RootPlan {
  plans: {
    planItems: {
      type: string;
      title: string;
      details: string;
      price: string;
      show: number;
    }[];
  };
}

interface RootCart {
  products: {
    cartItems: {
      showPrice: number;
      banner: string;
      title: string;
      price: string;
      courseDetails: string;
    }[];
  };
}

const Checkout = () => {
  const user = useSelector(selectUser);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedRadioValue, setSelectedRadioValue] = useState("");

  const cart = useSelector((state: RootCart) => state.products);
  const plan = useSelector((state: RootPlan) => state.plans.planItems);
  let cartTotalPrice = cart.cartItems
    .map((item) => item.showPrice)
    .reduce((prev, curr) => prev + curr, 0);
  let planTotalPrice = plan
    .map((item) => item.show)
    .reduce((prev, curr) => prev + curr, 0);

  const cartItems = cart.cartItems?.map((items, i) => (
    <div
      key={i}
      className="checkout-card"
    >
      <div>
        <img
          width="36.26"
          height="47.37"
          src={items.banner}
          alt="course"
        />
        <h3>{items.title}</h3>
      </div>
      <p>{items.price}</p>
    </div>
  ));

  const planItems = plan?.map((plans, i) => (
    <div
      key={i}
      className="checkout-plans-card"
    >
      <div>
        <div>
          <p>{plans.type} Plan</p>
        </div>
        <h3>{plans.title}</h3>
      </div>
      <p>{plans.price}</p>
    </div>
  ));

  const userPaystackConfig = {
    email: user?.email,
    amount: (cartTotalPrice + planTotalPrice) * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
  };

  const paystackConfig = { ...userPaystackConfig, ...config };

  const initializePayment = usePaystackPayment(paystackConfig);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedRadioValue(event.target.value);
  };

  const [modalStyle, setmodalstyle] = useState(false);

  const onSuccess = () => {
    setmodalstyle((prevModal) => !prevModal);
    // Implementation for whatever you want to do with reference and after success call.
  };

  // you can call this function anything
  const onClose = () => {
    // implementation for  whatever you want to do when the Paystack dialog closed.
    console.log("closed");
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    initializePayment(onSuccess, onClose);
  };

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.4 }}
      transition={{ duration: 0.5 }}
      className="checkout"
    >
      <section className="checkout-container">
        <form
          className="checkout-submit"
          onSubmit={handleSubmit}
        >
          <StyledFieldset>
            <h2>Checkout</h2>
            <label>Billing Address</label>
            <Countries />
            <FormControl>
              <div className="checkout-radio">
                <label>Payment Method</label>
                <div className="checkout-radio-cont">
                  <div>
                    <Radio
                      checked={selectedRadioValue === "paypal"}
                      onChange={handleRadioChange}
                      value="paypal"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "Paypal" }}
                    />
                    <img
                      src={PayPal}
                      alt="paypal"
                      width="82"
                      height="30"
                    />
                  </div>
                  <div>
                    <Radio
                      checked={selectedRadioValue === "debit/credit"}
                      onChange={handleRadioChange}
                      value="debit/credit"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "Debit/credit" }}
                    />

                    <p>Debit/Credit Card</p>
                    <img
                      src={visa}
                      alt="visa"
                    />
                    <img
                      src={mastercard}
                      alt="mastercard"
                    />
                  </div>
                </div>
              </div>
            </FormControl>
            <StyledFieldset className="checkout-input-container">
              <input
                type="text"
                placeholder="Name on the card"
                onChange={handleChange}
                required
              />
              <input
                type="number"
                placeholder="Card Number"
                onChange={handleChange}
                required
              />

              <div className="card-details">
                <input
                  type="text"
                  placeholder="MM/YY"
                  onChange={handleChange}
                  required
                />
                <input
                  type="number"
                  placeholder="CVC"
                  onChange={handleChange}
                  required
                />
              </div>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={handleChange}
                      defaultChecked
                      style={{
                        color: "#0A137C",
                        background: "white",
                      }}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                    />
                  }
                  label="Remember this card"
                />
              </FormGroup>
            </StyledFieldset>
          </StyledFieldset>
          <div className="order-experience-container">
            <div className="order-details">
              <div>
                <h4>Order Details</h4>
                {cart.cartItems.length > 0 && (
                  <p>
                    {cart.cartItems.length}{" "}
                    {cart.cartItems.length > 1 ? `Courses` : `Course`}
                  </p>
                )}

                {plan.length > 0 && (
                  <p>
                    {plan.length} {plan.length > 1 ? `Plans` : `Plan`}
                  </p>
                )}
              </div>
              {cartItems}
              {planItems}
            </div>
            <div className="order-summary">
              <h3>Order Summary</h3>
              <div>
                <h4>Total</h4>

                {cart.cartItems.length > 0 && (
                  <p>N{cartTotalPrice.toLocaleString()}</p>
                )}

                {plan.length > 0 && <p>N{planTotalPrice.toLocaleString()}</p>}
              </div>
              <PaystackHook />
            </div>
          </div>
        </form>
      </section>
      <AnimatePresence>
        {modalStyle && (
          <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0.4 }}
            transition={{ duration: 0.5 }}
            className="checkout-modal-container"
          >
            <CheckoutModal setmodalstyle={setmodalstyle} />
          </motion.section>
        )}
      </AnimatePresence>
    </motion.main>
  );
};

export default Checkout;
